import * as tslib_1 from "tslib";
import findReadWriteRecipient from '../actions/findReadWriteRecipient';
import { observer } from 'mobx-react';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import FindRecipient from 'owa-recipient-common/lib/components/FindRecipient';
import { isBrowserEdge } from 'owa-user-agent/lib/userAgent';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import FindRecipientInfo, { FindRecipientInfoType, } from 'owa-recipient-common/lib/components/FindRecipientInfo';
var styles = require('./AtMentionsResult.scss');
var classNames = require('classnames/bind').bind(styles);
var AtMentionsResult = /** @class */ (function (_super) {
    tslib_1.__extends(AtMentionsResult, _super);
    function AtMentionsResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchDirectoryAction = function (viewState) { return function () {
            findReadWriteRecipient(viewState, viewState.queryString, true /* searchDirectory */);
        }; };
        _this.addRecipientAction = function (viewState) { return function (recipientToAdd) {
            _this.props.addRecipientAction(recipientToAdd, viewState.wordBeforeCursor);
        }; };
        return _this;
    }
    AtMentionsResult.prototype.getInfoElementType = function (viewState) {
        var hasQueryString = !!viewState.queryString;
        if (viewState.isSearching) {
            return FindRecipientInfoType.Searching;
        }
        else if (!hasQueryString && viewState.recipientsShown.length == 0) {
            return FindRecipientInfoType.TypeToSearch;
        }
        else if (hasQueryString) {
            if (!viewState.hasSearchedDirectory) {
                return FindRecipientInfoType.SearchDirectory;
            }
            else {
                return FindRecipientInfoType.TopNResults;
            }
        }
        return FindRecipientInfoType.Default;
    };
    AtMentionsResult.prototype.render = function () {
        var _this = this;
        var _a = this.props, viewState = _a.viewState, targetPoint = _a.targetPoint, bufferZone = _a.bufferZone;
        return viewState.isPopupShown ? (React.createElement(Callout, { className: classNames(styles.callout, {
                animationStop: isBrowserEdge() /* see VSO:13872 Remove on release of RS3 */,
            }), gapSpace: bufferZone, targetPoint: targetPoint, useTargetPoint: true, isBeakVisible: false, setInitialFocus: false, directionalHint: getRTL() ? 6 /* bottomRightEdge */ : 4 /* bottomLeftEdge */ },
            viewState.recipientsShown.length != 0 && (React.createElement("div", { className: classNames(styles.scrollContainer, 'customScrollBar') },
                React.createElement("div", { className: styles.recipientCollection }, viewState.recipientsShown.map(function (result, index) { return (React.createElement(FindRecipient, { key: result.EmailAddress.EmailAddress, findRecipient: result, isHighlighted: viewState.selectedRecipientIndex == index, addRecipientAction: _this.addRecipientAction(viewState), maskRecipientAction: null })); })))),
            React.createElement(FindRecipientInfo, { infoType: this.getInfoElementType(viewState), queryString: viewState.queryString, highlighted: viewState.recipientsShown.length == viewState.selectedRecipientIndex, numberOfResults: viewState.recipientsShown.length, searchDirectoryAction: this.searchDirectoryAction(viewState) }))) : null;
    };
    AtMentionsResult = tslib_1.__decorate([
        observer
    ], AtMentionsResult);
    return AtMentionsResult;
}(React.Component));
export default AtMentionsResult;
export function showAtMentionsPopup(targetPoint, bufferZone, viewState, popupDiv, addRecipientAction) {
    ReactDOM.render(React.createElement(AtMentionsResult, { targetPoint: targetPoint, bufferZone: bufferZone, viewState: viewState, addRecipientAction: addRecipientAction }), popupDiv);
}
export function disposeAtMentionsPopup(popupDiv) {
    ReactDOM.unmountComponentAtNode(popupDiv);
}
//# sourceMappingURL=AtMentionsResult.js.map